export default __webpack_public_path__ + "static/media/logo_transparent.747ed4c4.png";